import { render, staticRenderFns } from "./ClientsEmailOcassion.vue?vue&type=template&id=e4a27bd0&scoped=true"
import script from "./ClientsEmailOcassion.vue?vue&type=script&lang=js"
export * from "./ClientsEmailOcassion.vue?vue&type=script&lang=js"
import style0 from "./ClientsEmailOcassion.vue?vue&type=style&index=0&id=e4a27bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a27bd0",
  null
  
)

export default component.exports